import Slider from "./modules/_slider.js";
import Header from "./modules/_header.js";
import Form from "./modules/_form.js";
import { initWaveMotionTicker } from "./modules/_waveMotionTicker.js";

class App {
  constructor() {
    this.routes();
  }

  routes() {
    const slider = new Slider();
    slider.init();

    const header = new Header();
    header.init();

    const form = new Form();
    form.init();

    document
      .querySelectorAll(".p-top-about__wave[data-wave-ticker]")
      .forEach((el) => initWaveMotionTicker(el));
  }
}

window.App = new App();
